import Header from '@/components/Header';
import Footer from '@/components/Footer';

const TrustPaymentPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <section className="pt-32 pb-20 bg-background">
        <div className="max-w-6xl mx-auto px-4">
          <div className="mb-8">
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-4">
              Trust Formation Donation
            </h1>
            <p className="text-xl text-muted-foreground">
              Select any cryptocurrency to make a donation, and we will begin establishing your private trust.
            </p>
          </div>

          <div className="flex justify-center">
            <div className="relative w-full max-w-[410px] mx-auto px-4 sm:px-0">
              <iframe 
                src="https://nowpayments.io/embeds/payment-widget?iid=6306828579" 
                width="100%" 
                height="696" 
                frameBorder="0" 
                scrolling="no" 
                style={{ overflowY: 'hidden', maxWidth: '410px' }}
                title="Trust Formation Donation"
              >
                Can't load widget
              </iframe>
              {/* Overlay to cover watermark at bottom */}
              <div className="absolute bottom-0 left-4 right-4 sm:left-0 sm:right-0 h-12 bg-white"></div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default TrustPaymentPage;